<template>
  <div class="l-bigContainer">
    <slot name="bg" />
    <div class="l-contentContainer">
      <div class="l-largeur90p">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutContentContainer'
}
</script>
